export const LocalStorageKeys = {
    USER_PHOTO: 'user-photo'
}